
export enum LocationType {
  EMPTY = 0,
  OFFICE = 1,
  AT_HOME = 2,
  VIA_COBROWSE = 3,
  CALL = 4
}

export const locationTypesReadable = {
  [LocationType.AT_HOME]: 'Thuis of locatie',
  [LocationType.OFFICE]: 'Op kantoor',
  [LocationType.VIA_COBROWSE]: 'Videobellen i.c.m. schermdelen',
  [LocationType.CALL]: 'Telefonisch',
}
